import { createContext } from 'react';

import { PlannedInfo } from '@/components/planning/dto';

interface PlannedInfoContextType {
	plannedInfo: PlannedInfo[] | null;
	setPlannedInfo: React.Dispatch<React.SetStateAction<PlannedInfo[] | null>> | null;
}

const defaultValuesPlannedInfo = {
	setPlannedInfo: null,
	plannedInfo: null,
};

export const PlannedInfoContext = createContext<PlannedInfoContextType>(defaultValuesPlannedInfo);
